
class mStoreLocatorHeader extends HTMLDivElement {
    constructor() {
        super();
        this.btnRedirect = this.querySelector('.back-result');
    }

    connectedCallback() {
        if (this.btnRedirect) {
            this.btnRedirect.addEventListener('click', (e) => {
                this.backToResult(e);
            });
        }
    }

    backToResult() {
        const urlRedirect = this.btnRedirect.dataset.redirectUrl;
        if (window.history.length > 1) {
            window.history.back();
        } else {
            window.location.href = urlRedirect;
        }
    }
}

customElements.define('m-store-locator-header', mStoreLocatorHeader, {
    extends: 'div'
});
